import { useSlots, useCssModule, computed } from "vue";
import { isVue2 } from "vue-demi";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "@fortawesome/vue-fontawesome";
import "vue-i18n";
import "./locales.js";
const COLORS = [
  "neutral",
  "neutral-0",
  "brand-primary",
  "feedback-success",
  "feedback-error",
  "feedback-warning",
  "feedback-info",
  "brand-support-01",
  "support-01",
  "support-02",
  "support-04"
];
const xBadge = "_xBadge_1dkvc_1";
const neutral = "_neutral_1dkvc_11";
const bold = "_bold_1dkvc_15";
const isDisabled = "_isDisabled_1dkvc_15";
const closeButton = "_closeButton_1dkvc_22";
const subtle = "_subtle_1dkvc_25";
const text = "_text_1dkvc_25";
const sizeSmall = "_sizeSmall_1dkvc_344";
const sizeLarge = "_sizeLarge_1dkvc_347";
const iconContainer = "_iconContainer_1dkvc_352";
const icon = "_icon_1dkvc_352";
const noLabel = "_noLabel_1dkvc_397";
const style0 = {
  xBadge,
  neutral,
  bold,
  isDisabled,
  closeButton,
  subtle,
  text,
  "neutral-0": "_neutral-0_1dkvc_36",
  "brand-primary": "_brand-primary_1dkvc_62",
  "feedback-success": "_feedback-success_1dkvc_87",
  "feedback-error": "_feedback-error_1dkvc_112",
  "feedback-warning": "_feedback-warning_1dkvc_137",
  "feedback-info": "_feedback-info_1dkvc_162",
  "brand-support-01": "_brand-support-01_1dkvc_187",
  "support-01": "_support-01_1dkvc_212",
  "support-02": "_support-02_1dkvc_237",
  "support-04": "_support-04_1dkvc_262",
  sizeSmall,
  sizeLarge,
  iconContainer,
  icon,
  noLabel
};
const { createIconProps } = useIconProps();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const __default__ = {
  name: "XBadge",
  components: { XIcon },
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (tag) => ["div", "li"].includes(tag)
    },
    size: {
      type: String,
      default: "",
      validation: (size) => ["", "sm", "lg"].includes(size)
    },
    color: {
      type: String,
      default: "neutral",
      validator: (color) => COLORS.includes(color)
    },
    bold: {
      type: Boolean,
      default: false
    },
    subtle: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    ...createIconProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const $style = useCssModule();
    const { t } = useI18n();
    const { formatTestId } = setupTestId(props);
    const { v2Listeners } = useListeners(["click"]);
    const { disabledClass } = getDisabledClass(props);
    const hasContent = computed(() => {
      var _a, _b, _c;
      if (!(slots == null ? void 0 : slots.default) || ((_a = slots == null ? void 0 : slots.default()) == null ? void 0 : _a.length) === 0) return false;
      const slotContent = slots.default()[0];
      if (isVue2) {
        return !!((_b = String(slotContent.text)) == null ? void 0 : _b.replace(/\s+/g, ""));
      }
      return !!((_c = String(slotContent.children)) == null ? void 0 : _c.replace(/\s+/g, ""));
    });
    const iconSize = computed(() => props.size === "sm" ? "xs" : null);
    const sizeClass = computed(() => ({
      [$style.sizeSmall]: props.size === "sm",
      [$style.sizeLarge]: props.size === "lg"
    }));
    const badgeClasses = computed(() => ({
      [$style[props.color]]: !!props.color,
      [$style.noLabel]: !hasContent.value,
      [$style.subtle]: props.subtle,
      [$style.bold]: props.bold,
      ...disabledClass.value,
      ...sizeClass.value
    }));
    function clickHandler(event) {
      if (props.disabled) {
        event.preventDefault();
      } else {
        emit("click", event);
      }
    }
    return { __sfc: true, createIconProps, createTestIdProp, setupTestId, createDisabledProp, getDisabledClass, props, slots, $style, t, emit, formatTestId, v2Listeners, disabledClass, hasContent, iconSize, sizeClass, badgeClasses, clickHandler, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_vm.tag, { tag: "component", class: [_setup.$style.xBadge, _setup.badgeClasses], attrs: { "data-testid": _setup.formatTestId(), "title": _vm.label } }, [_vm.icon ? _c("span", { class: _setup.$style.iconContainer }, [_c(_setup.XIcon, { class: _setup.$style.icon, attrs: { "icon": _vm.icon, "icon-style": _vm.iconStyle, "size": _setup.iconSize, "data-testid": _setup.formatTestId("icon") } })], 1) : _vm._e(), _setup.hasContent ? _c("span", { class: _setup.$style.text, attrs: { "data-testid": _setup.formatTestId("text") } }, [_vm._t("default")], 2) : _vm._e(), _vm.closable ? _c("button", _vm._g(_vm._b({ class: _setup.$style.closeButton, attrs: { "data-testid": _setup.formatTestId("closeButton"), "aria-disabled": `${_vm.disabled}`, "title": _setup.t("ds.xBadge.actions.close") }, on: { "click": _setup.clickHandler } }, "button", _vm.$attrs, false), _setup.v2Listeners), [_c(_setup.XIcon, { attrs: { "icon": "xmark-large", "icon-style": "fas", "size": "2xs" } })], 1) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XBadge = __component__.exports;
export {
  XBadge as default
};
